/* eslint-disable no-restricted-globals */
export var getLocalJSDate = function (dateTime) {
    return new Date(dateTime.get('year'), dateTime.get('month') - 1, dateTime.get('day'));
};
